<template>
  <form :class="style['form-wrap']" @submit.prevent="sendForm">
    <h2 :class="style.title">{{ $t('rental_car_form.pickup_title') }}</h2>
    <text-input
      v-model="rentalCarForm.pickupArea.text"
      :placeholder="$t('rental_car_form.pickup_area')"
      :read-only="true"
      :disabled="isPrefecturesEmpty"
      @click="openOptionPicker('pickupArea', 'pickupPrefectures')"
    />
    <text-input
      v-model="rentalCarForm.pickupShop.text"
      :placeholder="$t('rental_car_form.pickup_shop')"
      :read-only="true"
      :disabled="ispickupShopDisabled"
      @click="openOptionPicker('pickupShop', 'pickupShops')"
    />
    <text-input
      v-model="rentalCarForm.pickupTime"
      :placeholder="$t('rental_car_form.pickup_date_time')"
      :read-only="true"
      :disabled="isPickupTimeDisabled"
      @click="openDateTimePicker('pickupTime')"
    />
    <h2 :class="style.title">{{ $t('rental_car_form.return_title') }}</h2>
    <text-input
      v-model="rentalCarForm.returnArea.text"
      :placeholder="$t('rental_car_form.return_area')"
      :read-only="true"
      :disabled="isReturnAreaDisabled"
      @click="openOptionPicker('returnArea', 'returnPrefectures')"
    />
    <text-input
      v-model="rentalCarForm.returnShop.text"
      :placeholder="$t('rental_car_form.return_shop')"
      :read-only="true"
      :disabled="isReturnShopsDiabled"
      @click="openOptionPicker('returnShop', 'returnShops')"
    />
    <text-input
      v-model="rentalCarForm.returnTime"
      :placeholder="$t('rental_car_form.return_date_time')"
      :read-only="true"
      :disabled="isReturnTimeDisabled"
      @click="openDateTimePicker('returnTime')"
    />
    <div v-if="error" class="error-text">
      <span>{{ error }}</span>
    </div>
    <div>
      <button v-theme :class="style['btn-pink']" :disabled="!validateForm()" type="submit">
        {{ $t('next') }}
      </button>
    </div>
  </form>
</template>

<script>
import TextInput from 'UtilityComponents/TextInput.vue'
import style from './scss/_pages.scss'
import { EventBus } from 'ChatWidget/EventBus'
import {
  defaultStartDate,
  defaultEndDate,
  initialHourIncrement,
  initialMinuteIncrement,
  initialTime
} from 'javascript/Constants'
import { Chat } from 'src/apis'
import { dateTimeFormat, getRoundTime } from 'Utilities/TimerHelper'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useChatStore } from 'Store/chat'
import { useDatepickerStore } from 'Store/datepicker'
import { useDetailsPageStore } from 'Store/details-page'
import { mapState } from 'pinia'
import { useFormStore } from 'Store/form'

export default {
  components: {
    TextInput
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      chatStore: useChatStore(),
      datepickerStore: useDatepickerStore(),
      detailsPageStore: useDetailsPageStore(),
      formStore: useFormStore()
    }
  },

  data() {
    return {
      error: '',
      style
    }
  },
  computed: {
    ...mapState(useFormStore, {
      rentalCarForm: 'rentalCarForm'
    }),

    pickupTimeInfo() {
      return this.bottomPanelStore.pickupTimeInfo
    },

    returnTimeInfo() {
      return this.bottomPanelStore.returnTimeInfo
    },

    isPrefecturesEmpty() {
      return this.bottomPanelStore.pickupPrefectures.length < 1
    },
    ispickupShopDisabled() {
      return !this.rentalCarForm.pickupArea.text || this.bottomPanelStore.pickupShops.length < 1
    },
    isPickupTimeDisabled() {
      return !this.rentalCarForm.pickupShop.text || !this.bottomPanelStore.pickupTimeInfo
    },
    isReturnAreaDisabled() {
      return (
        !this.rentalCarForm.pickupArea.text ||
        !this.rentalCarForm.pickupShop.text ||
        this.bottomPanelStore.pickupPrefectures.length < 1
      )
    },
    isReturnShopsDiabled() {
      return !this.rentalCarForm.returnArea.text || this.bottomPanelStore.returnShops.length < 1
    },
    isReturnTimeDisabled() {
      return (
        !this.rentalCarForm.returnShop.text ||
        !this.rentalCarForm.pickupTime ||
        !this.bottomPanelStore.returnTimeInfo
      )
    }
  },
  created() {
    this.$rollbar.info(`rentalCarForm created ${this.chatStore.chatId}`)
  },
  methods: {
    sendForm() {
      if (!this.validateForm()) return
      const formData = {
        pickupArea: this.rentalCarForm.pickupArea.id,
        pickupShop: this.rentalCarForm.pickupShop.id,
        pickupTime: dateTimeFormat(this.rentalCarForm.pickupTime),
        returnArea: this.rentalCarForm.returnArea.id,
        returnShop: this.rentalCarForm.returnShop.id,
        returnTime: dateTimeFormat(this.rentalCarForm.returnTime)
      }
      this.detailsPageStore.closeDetailsPageShown()
      EventBus.$emit('pageDisabledActionWidget')
      Chat.sendMessage(this.composeReply(), { messageAction: JSON.stringify(formData) })
    },
    composeReply() {
      const replyArray = [
        `${this.$t('rental_car_form.pickup_shop')}: ${this.rentalCarForm.pickupShop.text}`,
        `${this.$t('rental_car_form.pickup_date_time')}: ${this.rentalCarForm.pickupTime}`,
        `${this.$t('rental_car_form.return_shop')}: ${this.rentalCarForm.returnShop.text}`,
        `${this.$t('rental_car_form.return_date_time')}: ${this.rentalCarForm.returnTime}`
      ]
      return replyArray.join('\n')
    },
    openOptionPicker(field, data) {
      this.bottomPanelStore.setBottomPanelDisplayList(data)
      this.formStore.setActiveField(field)
      this.bottomPanelStore.setBottomPanelComponent('OptionPickerPanel')
      this.$rollbar.info(`rentalCarForm openOptionPicker ${this.chatStore.chatId}`)
    },
    getDisabledDates(timeInfo, startDate) {
      const { end_date: endDate = defaultEndDate, disabled_dates: disabledDates = [] } = timeInfo
      return {
        to: new Date(startDate),
        from: new Date(endDate),
        dates: disabledDates
      }
    },
    openDateTimePicker(field) {
      const isReturnTime = field === 'returnTime'
      const timeInfo = isReturnTime ? this.returnTimeInfo : this.pickupTimeInfo
      const {
        actions,
        start_date: startDate = defaultStartDate,
        time_limited: timeLimited = []
      } = timeInfo
      const action = actions[0] || {}
      const hourIncrement = action.hour_increment || initialHourIncrement
      const minuteIncrement = action.minute_increment || initialMinuteIncrement

      let currentDate = isReturnTime ? this.rentalCarForm.pickupTime.split(' ')[0] : startDate
      let currentTime = action.default_time || initialTime
      const updatedStartDate = isReturnTime
        ? this.rentalCarForm.pickupTime.split(' ')[0]
        : startDate
      const selectedDateTime = this.rentalCarForm[field] && this.rentalCarForm[field].split(' ')
      if (selectedDateTime) {
        currentDate = selectedDateTime[0]
        currentTime = selectedDateTime[1]
      }
      this.formStore.setActiveField(field)
      this.bottomPanelStore.setBottomPanelComponent('DateTimePickerPanel')
      this.datepickerStore.setTimeSettings({
        datePickerWidgetId: this.chatStore.chatId,
        currentDate,
        currentTime: getRoundTime(currentTime, hourIncrement, minuteIncrement, timeLimited),
        defaultHourIncrement: hourIncrement,
        defaultMinuteIncrement: minuteIncrement,
        timeLimited
      })
      this.datepickerStore.setDisabledDates(this.getDisabledDates(timeInfo, updatedStartDate))
    },
    validateForm() {
      return (
        this.rentalCarForm.pickupArea.text &&
        this.rentalCarForm.pickupShop.text &&
        this.rentalCarForm.pickupTime &&
        this.rentalCarForm.returnArea.text &&
        this.rentalCarForm.returnShop.text &&
        this.rentalCarForm.returnTime
      )
    }
  }
}
</script>
